import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  ViewChild,
} from '@angular/core';
import { LinkCard } from '~app/modules/storyblok/models';
import {
  Direction,
  DirectionType,
  NUMBER_0,
  NUMBER_16,
  NUMBER_2,
  NUMBER_200,
  NUMBER_230,
  NUMBER_3,
  NUMBER_4,
  NUMBER_500,
  NUMBER_600,
  NUMBER_768,
} from '~shared/constants';
import { ApplicationEventType, CarouselActionType } from '~shared/modules/application-event/constants';
import { GaTrackingEventLabel } from '~shared/modules/ga-tracking/constants';
import { GtmDatalayerService } from '~shared/services/gtm-datalayer.service';

@Component({
  selector: 'app-popular-links-desktop',
  templateUrl: './popular-links-desktop.component.html',
  styleUrls: ['./popular-links-desktop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopularLinksDesktopComponent implements AfterViewInit {
  @Input() cardList: Array<LinkCard>;

  @ViewChild('productCarousel') productCarousel: ElementRef;

  scrollLeft = NUMBER_0;
  arrowEnabled = true;
  showLeftArrow = false;
  showRightArrow = true;
  DIRECTION = Direction;
  sbFormatParam = '/m/';

  constructor(private cd: ChangeDetectorRef, private gtmDatalayerService: GtmDatalayerService) {}

  ngAfterViewInit(): void {
    this.updateArrowsVisibility();
    this.cd.detectChanges();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    const currentScrollLeft = this.productCarousel.nativeElement.scrollLeft;
    this.updateArrowsVisibility();
    this.productCarousel.nativeElement.scrollLeft = currentScrollLeft;
    this.scrollLeft = currentScrollLeft;
  }

  updateArrowsVisibility(): void {
    const carousel = this.productCarousel.nativeElement;
    const maxScrollLeft = carousel.scrollWidth - carousel.clientWidth;

    this.showLeftArrow = this.scrollLeft > NUMBER_0;
    this.showRightArrow = this.scrollLeft < maxScrollLeft;
    this.cd.detectChanges();
  }

  getScrollLeft(): number {
    const carouselWidth = this.productCarousel?.nativeElement?.offsetWidth;
    const cardWidth = carouselWidth <= NUMBER_768 ? NUMBER_200 : NUMBER_230;
    const padding = NUMBER_16;
    const productsBySwipe =
      carouselWidth <= NUMBER_600
        ? NUMBER_2
        : carouselWidth > NUMBER_600 && carouselWidth <= NUMBER_768
        ? NUMBER_3
        : NUMBER_4;

    return (cardWidth + padding) * productsBySwipe;
  }

  clickRightArrow() {
    if (this.arrowEnabled) {
      this.arrowEnabled = false;
      const scrollAmount = this.getScrollLeft();
      this.scrollLeft = Math.min(
        this.scrollLeft + scrollAmount,
        this.productCarousel.nativeElement.scrollWidth - this.productCarousel.nativeElement.clientWidth
      );
      this.productCarousel.nativeElement.scrollLeft = this.scrollLeft;
      setTimeout(() => {
        this.arrowEnabled = true;
        this.updateArrowsVisibility();
      }, NUMBER_500);
    }
  }

  clickLeftArrow() {
    if (this.arrowEnabled) {
      this.arrowEnabled = false;
      const scrollAmount = this.getScrollLeft();
      this.scrollLeft = Math.max(this.scrollLeft - scrollAmount, NUMBER_0);
      this.productCarousel.nativeElement.scrollLeft = this.scrollLeft;
      setTimeout(() => {
        this.arrowEnabled = true;
        this.updateArrowsVisibility();
      }, NUMBER_500);
    }
  }

  canScrollRight(): boolean {
    return (
      this.productCarousel?.nativeElement?.scrollWidth >
      this.productCarousel?.nativeElement?.offsetWidth + this.scrollLeft
    );
  }

  canScrollLeft(): boolean {
    return this.scrollLeft > NUMBER_0;
  }

  onProductCarouselNavigation(direction: DirectionType): void {
    this.gtmDatalayerService.gtagEvent({
      category: ApplicationEventType.Interaction,
      action: CarouselActionType.ContentCarouselButton,
      label: direction === this.DIRECTION.RIGHT ? GaTrackingEventLabel.Right : GaTrackingEventLabel.Left,
    });
  }
}
